import React, { useState, useEffect, useCallback } from "react";
import { Select, Spin,Tag  } from "antd";
import { debounce } from "lodash";

const { Option } = Select;

const CustomFilterSelect = ({
  label,
  fetchOptions,
  filterKey,
  onChange,
  renderOption,
  placeholder = `Select ${label}`,
  disabled = false,
  mode = "default",
  value = undefined,
  copyPaste = false,
  className
}) => {
  const [options, setOptions] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  // Controls the Select's own search box (searchValue prop below) - reset
  // after every selection so the option list goes back to showing
  // everything instead of staying filtered by whatever was last typed.
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [autoSelected, setautoSelected] = useState([]);
  const [invalidEmails, setinvalidEmails] = useState([]);

  const loadOptions = useCallback(
    async (search = "", pageNo = 0, type = "", search_list="") => {
      try {
        setFetching(true);
        const result = await fetchOptions(pageNo, search, type, search_list);

        if (type === 'copy_paste' && copyPaste) {
          let copy_of_autoselected = autoSelected
          console.log(copy_of_autoselected, 1)
          if (result.avl_user.length>0) {
            // setting valid options
            setOptions((prev) => {
              const existing = new Set(prev.map((o) => o.value));
              const newOpts = result.avl_user
                .filter((o) => !existing.has(o.value));
              return [...prev, ...newOpts];
            });
            
            // get the valid option id and set to auto selected
            const avl_user = [...result.avl_user]
            const user_to_select = avl_user.map(a=>{return a.value}) // id list
            const merged_new_val = [...copy_of_autoselected, ...user_to_select]; // merge with previous
            copy_of_autoselected = Array.from(new Map(merged_new_val.map(t => [t, t])).values()); // store in local variable later update main variable
            console.log(copy_of_autoselected, 2)
            
          }
          if (result.not_avail.length>0) {
            const merged_not_valid = [...copy_of_autoselected, ...result.not_avail];
            copy_of_autoselected = Array.from(new Map(merged_not_valid.map(t => [t, t])).values()); // remove not valid duplicated
            console.log(copy_of_autoselected, 3)

            setinvalidEmails((prev) => { // set invalid seperate list
              const mergednon = [...prev, ...result.not_avail];
              return Array.from(new Set(mergednon));
            });
          }
          console.log(copy_of_autoselected, 4)
          // update the value to original value
          setautoSelected(copy_of_autoselected);  //auto select for select
          handleChange(copy_of_autoselected); // emit the newly changes value

        } else {
          if (result && result.length > 0) {
            if (pageNo === 0) {
              setOptions(result);
            } else {
              setOptions((prev) => {
                const existing = new Set(prev.map((o) => o.value));
                const newOpts = result.filter((o) => !existing.has(o.value));
                return [...prev, ...newOpts];
              });
            }
            setHasMore(result.length > 0);
          } else {
            if (pageNo === 0) setOptions([]);
            setHasMore(false);
          }
        }
      } catch {
        if (pageNo === 0) setOptions([]);
        setHasMore(false);
      } finally {
        setFetching(false);
      }
    },
    [fetchOptions, autoSelected]
  );

  // Single useEffect for search and page change
  useEffect(() => {
    // Don't load if no more data on next pages
    if (page > 0 && !hasMore) return;

    loadOptions(searchValue, page);
  }, [searchValue, page, loadOptions, hasMore]);


  const debouncedSearch = useCallback(
    debounce((val) => {
      setSearchValue(val);
      setPage(0);
      setHasMore(true);
    }, 400), // no leading option
    []
  );

  const handleSearch = (value) => {
    setSearchText(value);
    debouncedSearch(value);
  };

  const handlePopupScroll = (e) => {
    const target = e.target;
    if (
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 1 &&
      !fetching &&
      hasMore
    ) {
      setPage((prev) => prev + 1);
    }
  };

   // 🔹 Detect paste (comma-separated emails)
  const handlePaste = async (e) => {
    if (copyPaste===true){
      const pastedText = e.clipboardData.getData("text");
      if (pastedText && pastedText.includes("@")) {
        e.preventDefault(); // stop default input behavior
        const emails = pastedText
          .split(/[,\n\s]+/)
          .map((x) => x.trim())
          .filter(Boolean)
          .join(",");
        await loadOptions("", 0, 'copy_paste', emails);
      }
    }
  };

  const handleChange = async(val) => {
    setautoSelected(val)
    onChange(filterKey, val)
    // Remove any invalid emails that were deleted
    setinvalidEmails((prevInvalid) =>
      prevInvalid.filter((email) => val.includes(email))
    );
    // Back to showing everything after a pick, instead of staying filtered
    // by whatever search term was used to find that option.
    setSearchText("");
    setSearchValue("");
    setPage(0);
    setHasMore(true);
  }

  
  // Custom tag render: invalid emails in red
  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    
    if (invalidEmails.includes(value)) {
      return (
        <Tag color="red" closable={closable} onClose={onClose}>
          {value} (Not Found)
        </Tag>
      );
    }
    
    return (
      <Tag closable={closable} onClose={onClose}>
        {label}
      </Tag>
    );
  };

  return (
    <div style={{ minWidth: 210 }}>
      <style>{`
        .user_auto_select .ant-select-selector {
          max-height: 300px;
          overflow-y: auto;
        }
      `}</style>
      <Select
        className={className ? `user_auto_select ${className}` : "user_auto_select"}
        mode={mode}
        showSearch
        allowClear
        placeholder={placeholder}
        onChange={handleChange}
        onSearch={handleSearch}
        searchValue={searchText}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        onPopupScroll={handlePopupScroll}
        disabled={disabled}
        style={{ width: "100%" }}
        loading={fetching}
        listHeight={200}
        {...(copyPaste
          ? { onPaste: handlePaste, value: autoSelected, tagRender: tagRender }
          : {  })} // default value if not copyPaste
          
      >
        {fetching && (
          <Option key="loading" disabled style={{ textAlign: "center" }}>
            <Spin size="small" style={{ color: "red", marginRight: 8 }} /> Loading...
          </Option>
        )}
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {renderOption ? renderOption(option) : option.label}
          </Option>
        ))}
        
      </Select>
      {/* User info / error message */}
      <div style={{ marginTop: 4, fontSize: 12, color: "#555" }}>
        {copyPaste && (
          <>
            <div>Note: You can copy-paste only email addresses.</div>
            {invalidEmails.length > 0 && (
              <div style={{ color: "red" }}>
                Unmatched emails: {invalidEmails.join(", ")}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CustomFilterSelect;
